import { fn, get } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import { trackedFunction } from 'reactiveweb/function';

import Newsletter from 'umg-ember-backend/components/record-detail/forms/newsletter/index';
import Button from 'umg-ember-backend/components/ui/button/index';
import Modal from 'umg-ember-backend/components/ui/modal/index';
import Window from 'umg-ember-backend/components/ui/window/index';
import recordHeadlineOrNew from 'umg-ember-backend/helpers/record-headline-or-new';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class RecordDetailFormsStoryContentNewsletter extends Component {
  // Services
  @service confirm;
  @service recordRelationships;

  loadLegalContext = trackedFunction(this, async () => {
    const ownedByChannel = await this.args.story.ownedByChannel;
    const legalContext = await ownedByChannel?.legalContext;

    return legalContext?.id;
  });

  // Functions
  confirmRollbackChanges = async () => {
    const scope = 'confirm.discard';

    if (!this.recordRelationships.hasDirtyFields(this.args.record)) {
      return this.args.onCloseEditing();
    }

    let ok = await this.confirm.ask(`${scope}.title`, `${scope}.message`);

    if (!ok) {
      return false;
    }

    this.args.record.rollbackAttributes();
    this.recordRelationships.rollback(this.args.record);
    return this.args.onCloseEditing();
  };

  // Template
  <template>
    <Modal
      @onClose={{this.confirmRollbackChanges}}
      @dataDependencies={{@record}}
      as |record onClose|
    >
      <Window>
        <:title>
          {{recordHeadlineOrNew record}}
        </:title>
        <:body>
          <Newsletter
            @model={{record}}
            @recordType={{getRecordType record}}
            @newsletterArtist={{get @story.artists 0}}
            @loadLegalContext={{this.loadLegalContext}}
          />
        </:body>
        <:bottombar>
          <Button
            @disabled={{record.validations.isInvalid}}
            @label={{t 'record_detail.forms.story.content.newsletter.save'}}
            {{on 'click' (fn @onSaveNewsletter record)}}
          />

          <Button
            @style='grey'
            @label={{t 'record_detail.forms.story.content.newsletter.cancel'}}
            {{on 'click' onClose}}
          />
        </:bottombar>
      </Window>
    </Modal>
  </template>
}
